/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("RadioGroupController", ["ValueContainerControllerBase", "ControllerFactory", "WidgetFactory"], function (context, cls) {
  /**
   * @class RadioGroupController
   * @memberOf classes
   * @extends classes.ValueContainerControllerBase
   */
  class RadioGroupController extends cls.ValueContainerControllerBase /** @lends classes.RadioGroupController.prototype */ {
    static __name = "RadioGroupController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.DialogTypeVMBehavior);
      if (this.isInTable()) {
        this._addBehavior(cls.TableSizeVMBehavior);
      }
      if (!this.isInTable() || this.isInFirstTableRow()) {
        this._addBehavior(cls.LayoutInfoVMBehavior);
      }
      this._addBehavior(cls.StyleVMBehavior);
      // END WARNING

      // pseudo-selector behaviors
      this._addBehavior(cls.ActivePseudoSelectorBehavior);
      this._addBehavior(cls.DialogTypePseudoSelectorBehavior);
      if (this.isInMatrix()) {
        this._addBehavior(cls.MatrixCurrentRowVMBehavior);
      }
      this._addBehavior(cls.FontStyle4STBehavior);
      this._addBehavior(cls.FontSize4STBehavior);
      this._addBehavior(cls.FontColor4STBehavior);
      this._addBehavior(cls.Border4STBehavior);
      this._addBehavior(cls.Reverse4STBehavior);

      // vm behaviors
      this._addBehavior(cls.EnabledVMBehavior);
      this._addBehavior(cls.HiddenVMBehavior);
      this._addBehavior(cls.ColorVMBehavior);
      this._addBehavior(cls.BackgroundColorVMBehavior);
      this._addBehavior(cls.FontWeightVMBehavior);
      this._addBehavior(cls.FontFamilyVMBehavior);
      this._addBehavior(cls.TextDecorationVMBehavior);
      this._addBehavior(cls.ItemVMBehavior);
      this._addBehavior(cls.ValueVMBehavior);
      this._addBehavior(cls.OrientationVMBehavior);
      this._addBehavior(cls.TitleVMBehavior);
      this._addBehavior(cls.StretchVMBehavior);
      //Field Validation
      this._addBehavior(cls.NotNullVMBehavior);
      this._addBehavior(cls.RequiredVMBehavior);
      this._addBehavior(cls.IncludeVMBehavior);

      // ui behaviors
      this._addBehavior(cls.ValueChangedUIBehavior);
      this._addBehavior(cls.RequestFocusUIBehavior);
      if (this.isInTable()) {
        this._addBehavior(cls.TableImageVMBehavior);
        this._addBehavior(cls.RowSelectionUIBehavior);
        this._addBehavior(cls.TableItemCurrentRowVMBehavior);
      }
    }

    _getWidgetType(kind) {
      let type;
      if (kind === "Construct") {
        type = "DummyRadioGroup";
      } else {
        type = super._getWidgetType(kind);
      }
      return type;
    }

    _createWidget(type) {
      const radioGroup = super._createWidget(type);

      const choices = this.getNodeBindings()
        .decorator.getChildren()
        .map(function (item) {
          return {
            value: item.attribute("name"),
            text: item.attribute("text")
          };
        });
      radioGroup.setItems(choices);
      radioGroup.setOrientation(this.getNodeBindings().decorator.attribute("orientation"));
      return radioGroup;
    }
  }

  cls.RadioGroupController = RadioGroupController;
  cls.ControllerFactory.register("RadioGroup", cls.RadioGroupController);
});
